export var linkMixin = function linkMixin(hoverTextDecoration) {
  return "\n    border-radius: 1px;\n    outline: none;\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: " + hoverTextDecoration + ";\n    }\n  ";
};
export var linkDisabledMixin = function linkDisabledMixin() {
  return "\n    box-shadow: none;\n    cursor: default;\n    pointer-events: none;\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: none;\n    }\n  ";
};
export var linkUseColorsMixin = function linkUseColorsMixin(mainColor, hoverColor, activeColor) {
  return "\n    color: " + mainColor + ";\n\n    &:hover {\n      color: " + hoverColor + ";\n    }\n\n    &:active {\n      color: " + activeColor + ";\n    }\n  ";
};
export var linkUseLineHovered = function linkUseLineHovered(linkLineHoverBorderBottomStyle) {
  return "\n    animation: none !important;\n    border-bottom-style: " + linkLineHoverBorderBottomStyle + ";\n  ";
};